import { CommentSystemIcon, LocationSystemIcon, PhoneSystemIcon } from '@nib/icons';
import getArhiConfig from './arhi';
import _socialMedia from './_socialMedia';
import { getBaseUrl } from './utils';
const ABSOLUTE_BASEURL = 'https://www.nib.com.au';
const getProvidersConfig = config => {
  const baseUrl = getBaseUrl(config, ABSOLUTE_BASEURL);
  const arhiConfig = getArhiConfig(config);
  return {
    ...arhiConfig,
    id: 'footer-providers',
    columns: [],
    contact: {
      socialLinks: _socialMedia,
      contactLinks: [{
        id: 'ga-footer-contact-us',
        title: 'Contact us',
        url: `${baseUrl}/providers/contact-us`,
        icon: PhoneSystemIcon
      }, {
        id: 'ga-footer-find-provider',
        title: 'Find a Provider',
        url: `${baseUrl}/find-a-provider`,
        icon: LocationSystemIcon
      }, {
        id: 'ga-footer-dental-care',
        title: 'Find an nib Dental Care Centre',
        url: `${baseUrl}/health-information/first-choice-dental`,
        icon: LocationSystemIcon
      }, {
        id: 'ga-footer-eye-care',
        title: 'Find an nib First Choice Optical provider',
        url: `${baseUrl}/health-information/first-choice-optical`,
        icon: LocationSystemIcon
      }, {
        id: 'ga-footer-feedback-and-complaints',
        title: 'Feedback & complaints',
        url: `${baseUrl}/health-information/member-services/feedback-and-complaints`,
        icon: CommentSystemIcon
      }]
    },
    smallFooterConfig: {
      ...arhiConfig.smallFooterConfig,
      id: 'small-footer-providers'
    }
  };
};
export default getProvidersConfig;